const CodeBlueMenu = [
    {
      icon: "edit",
      key: "Code.Blue.Master",
      name: "Code Blue Manager",
      url: "home/app/Code-Blue-Manager",
      description: "",
      productionReady: true,
    },
    {
      icon: "summarize",
      key: "Code.Blue.Reports",
      name: "Code Blue Reports",
      url: "home/app/Code-Blue-Reports",
      description: "",
      productionReady: true,
    },
  ];
  
  export { CodeBlueMenu };
  